import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { AuthState } from 'src/reducers/auth/model';

import { getMyProfile } from './thunks';

const initialState: AuthState = {
  isLogged: null,
  ignoreRedirect: false,
};

const authSlice = createSlice({
  name: '@auth',
  initialState,
  reducers: {
    updateMyProfile: (state, action: PayloadAction<AuthState['myProfile']>) => {
      state.myProfile = action.payload;
    },
    setLogged: (state, action: PayloadAction<AuthState['isLogged']>) => {
      state.isLogged = action.payload;
    },
    setIgnoreRedirect: (state, action: PayloadAction<AuthState['ignoreRedirect']>) => {
      state.ignoreRedirect = action.payload;
    },
    resetMyProfile: state => {
      state.myProfile = undefined;
    },
  },
  extraReducers: builder => {
    builder.addCase(getMyProfile.fulfilled, (state, action) => {
      state.myProfile = action.payload;
      state.isLogged = true;
    });
    builder.addCase(getMyProfile.rejected, state => {
      state.isLogged = false;
      state.myProfile = undefined;
    });
  },
});

export { getMyProfile } from './thunks';

export const authAction = {
  ...authSlice.actions,
  getMyProfile,
};

export default authSlice.reducer;
